// An environment's VPN (D80): its settings and state, connect (the IdP link and the one-time
// callback path the relay command posts to), disconnect. The API decides who may.
import { queryOptions } from "@tanstack/react-query";

import { api, type Schemas } from "../api/client";
import { unwrap } from "../api/queries";

export type EnvironmentVpn = Schemas["EnvironmentVpnDto"];
export type VpnLogin = Schemas["VpnLoginDto"];
export type VpnSettingsBody = Schemas["VpnSettingsBody"];
export type VpnState = "absent" | "down" | "signing_in" | "up";

const path = (id: string) => ({ params: { path: { environment_id: id } } });

export const vpnState = (v: Pick<EnvironmentVpn, "state">): VpnState =>
  v.state === "down" || v.state === "signing_in" || v.state === "up" ? v.state : "absent";

/** `refetchInterval` while a sign-in is waiting, so the page sees the tunnel come up. */
export const environmentVpnQuery = (id: string, refetchInterval: number | false = false) =>
  queryOptions({
    queryKey: ["environment-vpn", id],
    queryFn: () => unwrap(api.GET("/api/environments/{environment_id}/vpn", path(id))),
    refetchInterval,
  });

export const saveVpn = (id: string, body: VpnSettingsBody) =>
  unwrap(api.PUT("/api/environments/{environment_id}/vpn", { ...path(id), body }));

export const connectVpn = (id: string) => unwrap(api.POST("/api/environments/{environment_id}/vpn/connect", path(id)));

export async function disconnectVpn(id: string): Promise<void> {
  await unwrap(api.POST("/api/environments/{environment_id}/vpn/disconnect", path(id)));
}
